import { render, staticRenderFns } from "./UpdateAnnouncementTypePage.vue?vue&type=template&id=6a541bd3&scoped=true"
import script from "./UpdateAnnouncementTypePage.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncementTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a541bd3",
  null
  
)

export default component.exports